<template>
  <user-domains />
</template>

<script>
import UserDomains from "@/components/Ondemand/Analytic/Analytic.vue";

export default {
  components: {
    UserDomains,
  },
};
</script>

<style></style>